import {
  STEP_USER_REGISTRATION,
  registerUser,
  registrationMoveToStep,
  validatePhoneCode
} from './registrationActions';
import { createReducer } from 'actionware';
import { createState } from 'stateware';

const initialState = createState({
  currentStep: STEP_USER_REGISTRATION,
  isValidPhoneCode: null,
  userData: {
    userName: null,
    phone: null,
    email: null,
    password: null
  }
});

export default createReducer(initialState)
  .on(registerUser, (state, userData) =>
    initialState.copy({
      userData
    })
  )
  .on(registrationMoveToStep, ({ userData }, currentStep) =>
    initialState.copy({
      userData,
      currentStep
    })
  )
  .on(validatePhoneCode, (state, isValidPhoneCode) =>
    state.copy({
      isValidPhoneCode
    })
  );
